// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form .mantine-TextInput-input,
form .mantine-DateInput-input,
form .mantine-Select-input,
form .mantine-NumberInput-input,
form .mantine-PasswordInput-input,
form .mantine-Autocomplete-input,
form .mantine-TagsInput-input {
  height: 2.75rem !important;
  border-radius: 0.375rem !important;
}
form .mantine-Textarea-input {
  min-height: 2.75rem !important;
  border-radius: 0.375rem !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Input.scss"],"names":[],"mappings":"AACE;;;;;;;EAOE,0BAAA;EACA,kCAAA;AAAJ;AAGE;EACE,8BAAA;EACA,kCAAA;AADJ","sourcesContent":["form {\n  .mantine-TextInput-input,\n  .mantine-DateInput-input,\n  .mantine-Select-input,\n  .mantine-NumberInput-input,\n  .mantine-PasswordInput-input,\n  .mantine-Autocomplete-input,\n  .mantine-TagsInput-input {\n    height: 2.75rem !important;\n    border-radius: 0.375rem !important;\n  }\n\n  .mantine-Textarea-input {\n    min-height: 2.75rem !important;\n    border-radius: 0.375rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
